export default __webpack_public_path__ + "static/media/demo4.473db1b4.gif";